/* eslint-disable no-undef */
/* eslint-disable linebreak-style */
/* eslint-disable no-undef */
/**
 * React Facebook Pixel Module
 *
 * https://github.com/zsajjad/react-facebook-pixel
 */

//
let initialized = false;
let debug = false;

/**
 * Utilities
 */

const verifyInit = () => {
  if (!initialized) {
    // eslint-disable-next-line no-console
    console.warn('Pixel not initialized before using call ReactPixel.init with required params');
  }
  return initialized;
};

//
const log = (...args) => {
  // eslint-disable-next-line no-console
  console.info(...['[react-facebook-pixel]'].concat(args));
};

//
const defaultOptions = {
  autoConfig: true,
  debug: false
};

//
export default {
  init(pixelId, advancedMatching = {}, options = defaultOptions) {
    if (!pixelId) {
      // eslint-disable-next-line no-console
      console.warn('Please insert pixel id for initializing');
    } else {
      if (options.autoConfig === false) {
        fbq('set', 'autoConfig', false, pixelId); // eslint-disable-line no-undef
      }

      fbq('init', pixelId, advancedMatching); // eslint-disable-line no-undef

      initialized = true;
      debug = options.debug;
    }
  },

  pageView() {
    if (!verifyInit()) {
      return;
    }

    fbq('track', 'PageView'); // eslint-disable-line no-undef

    if (debug) {
      log('called fbq(\'track\', \'PageView\');');
    }
  },

  track(title, data) {
    if (!verifyInit()) {
      return;
    }

    fbq('track', title, data); // eslint-disable-line no-undef

    if (debug) {
      log(`called fbq('track', '${title}');`);

      if (data) {
        log('with data', data);
      }
    }
  },

  trackCustom(event, data) {
    if (!verifyInit()) {
      return;
    }

    fbq('trackCustom', event, data); // eslint-disable-line no-undef

    if (debug) {
      log(`called fbq('trackCustom', '${event}');`);

      if (data) {
        log('with data', data);
      }
    }
  },

  trackSingleCustom(pixel, event, data) {
    if (!verifyInit()) {
      return;
    }

    fbq('trackSingleCustom', pixel, event, data); // eslint-disable-line no-undef

    if (debug) {
      log(`called fbq('trackSingleCustom', '${pixel}', '${event}');`);

      if (data) {
        log('with data', data);
      }
    }
  },

  grantConsent() {
    if (!verifyInit()) {
      return;
    }

    // eslint-disable-next-line no-undef
    fbq('consent', 'grant');

    if (debug) {
      log('called fbq(\'consent\', \'grant\');');
    }
  },

  revokeConsent() {
    if (!verifyInit()) {
      return;
    }

    // eslint-disable-next-line no-undef
    fbq('consent', 'revoke');

    if (debug) {
      log('called fbq(\'consent\', \'revoke\');');
    }
  },

  fbq(...args) {
    if (!verifyInit()) {
      return;
    }

    fbq(...args); // eslint-disable-line no-undef

    if (debug) {
      log(`called fbq('${args.slice(0, 2).join('\', \'')}')`);

      if (args[2]) {
        log('with data', args[2]);
      }
    }
  },
};
